export default "__VITE_ASSET__aba92ce4__"